// export const generateBreadcrumbs = (pathName: string) => {
//     let breadcrumbs: { name: string; link: string }[] = [];

//     // Logic to generate breadcrumbs based on pathName
//     if (pathName === '/') {
//       breadcrumbs = [{ name: 'Home', link: '/' }];
//     } else if (pathName.startsWith('/admin')) {
//       breadcrumbs = [
//         { name: 'Home', link: '/' },
//         { name: 'Admin', link: '/admin' },
//       ];
//     } else {
//       // Default breadcrumbs for other routes
//       breadcrumbs = [{ name: 'Home', link: '/' }];
//     }

//     return breadcrumbs;
//   };

export const generateBreadcrumbs = (pathName: string, translation: Function) => {
  const breadcrumbs: { name: string; link: string }[] = [];

  if (pathName === '/' || pathName === '') {
    breadcrumbs.push({
      name: translation('dashboard.breadcrumb.label.home'),
      link: '/',
    });
  }

  const segments = pathName.split('/').filter(segment => segment !== '');

  let currentPath = '';
  for (let i = 0; i < segments.length; i++) {
    let displayName = segments[i];

    if (segments[i - 1] === 'campaigns' && segments[i] !== 'myTeam' && segments[i] !== 'participants') {
      displayName = translation('dashboard.breadcrumb.label.myProgress');
    }

    // Check if the current segment is a number and the previous segment is 'teams'
    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'teams') {
      displayName = translation('dashboard.breadcrumb.label.teamDetails');
    }

    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'participants') {
      displayName = translation('dashboard.breadcrumb.label.participants');
    }

    if (segments[i] === 'myTeam' || (!isNaN(Number(segments[i])) && segments[i - 1] === 'myTeam')) {
      displayName = translation('dashboard.breadcrumb.label.myTeam');
    }

    if (segments[i] === 'join-team' || (!isNaN(Number(segments[i])) && segments[i - 1] === 'join-team')) {
      displayName = translation('dashboard.breadcrumb.label.joinTeam');
    }

    if (segments[i] === 'edit' && segments[i - 1] === 'profile') {
      displayName = translation('dashboard.breadcrumb.label.editProfile');
    }

    if (segments[i] === 'join-team') {
      displayName = translation('dashboard.breadcrumb.label.joinTeam');
    }

    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'coach') {
      displayName = translation('dashboard.breadcrumb.label.coachProfile');
    }

    // Check if the current segment is 'user'
    if (segments[i] === 'user') {
      displayName = translation('dashboard.breadcrumb.label.participantProfile');
    }

    if (segments[i] === 'create-team') {
      displayName = translation('dashboard.breadcrumb.label.createTeam');
    }

    if (segments[i] === 'privacy-security') {
      displayName = translation('dashboard.breadcrumb.label.privacyPolicy');
    }

    if (segments[i] === 'terms-and-conditions') {
      displayName = translation('dashboard.breadcrumb.label.termsAndConditions');
    }

    if (segments[i] === 'profile') {
      displayName = translation('dashboard.breadcrumb.label.profile');
    }

    currentPath += `/${segments[i]}`;

    if (!breadcrumbs.find(i => i.name === displayName) && displayName !== 'campaigns' && displayName !== 'Join Team') {
      breadcrumbs.push({
        name: displayName.charAt(0).toUpperCase() + displayName.slice(1),
        link: currentPath,
      });
    }
  }

  if (breadcrumbs.length > 0) {
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    const index = lastBreadcrumb.link.indexOf('?');
    if (index !== -1) {
      lastBreadcrumb.link = lastBreadcrumb.link.substring(0, index);
    }
  }

  return breadcrumbs;
};
